class ComponentFilter extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      form: this.querySelector(".filter-form"),
      bodyFilter: this.querySelector(".filter-desk"),
      bodyFilterSortMobile: this.querySelector(".filter-mobile"),
      heightFilter: this.querySelector(".filter-body"),
      bodySort: this.querySelector(".filter-sort"),
      btnFilter: this.querySelector(".btn-filter"),
      btnSort: this.querySelector(".btn-sort"),
      btnCloseFilterSort: this.querySelector(".close-modal-filter"),
      itemFilter: this.querySelectorAll(".item-filter"),
      btnVisibleOpcoesFilter: this.querySelectorAll(".filter-group-summary"),
      btnCheckMobile: this.querySelectorAll(".btn-check"),
      btnMore: this.querySelectorAll(".btn-more") ? this.querySelectorAll(".btn-more") : null,

      groupSort: this.querySelector(".group-sort") ? this.querySelector(".group-sort") : null,
      timeEffectSort: null,
      windowDesk: this._screen() > 641 ? true : false,
    };

    this.init();
  }

  init() {
    window.addEventListener("resize", this.resizeWindow.bind(this));
    if(this.elements.btnFilter) this.elements.btnFilter.addEventListener("click", this.displayFilter.bind(this));
    if(this.elements.btnCloseFilterSort) this.elements.btnCloseFilterSort.addEventListener("click", this.closeFilterSort.bind(this));

    if (this.elements.groupSort != null) {
      this.elements.groupSort.addEventListener("mouseleave", this._closeSort.bind(this));
      this.elements.groupSort.addEventListener("mouseenter", this.displaySort.bind(this));
    }

    this.elements.btnVisibleOpcoesFilter.forEach((item) => {
      item.addEventListener("click", this._visibleOptionsFilter.bind(this));
    });

    if (this.elements.btnMore != null) {
      this.elements.btnMore.forEach((item) => {
        item.addEventListener("click", this._visibleOptions.bind(this));
      });
    }

    this.elements.btnCheckMobile.forEach((item) => {
      item.addEventListener("click", this._checkMobile.bind(this));
    });

    this.elements.itemFilter.forEach((item) => {
      item.addEventListener("change", this._submitFilter.bind(this));
    });
  }

  _submitFilter() {
    const componentSort = document.querySelector("component-sorting");
    if (componentSort) {
      const selectedSort = componentSort.querySelector("span.filter-sort-options.selected");
      if (selectedSort) {
        const sort = selectedSort.getAttribute("data-option");

        this.elements.form.insertAdjacentHTML("beforeend", `<input type="hidden" name="sort_by" value="${sort}">`);
      }
    }

    this.elements.form.submit();
  }

  _checkMobile(e) {
    if (this._screen() > 641) return false;

    let element = e.target;
    if (!element.classList.contains("btn-check")) {
      element = e.target.parentNode;
    }

    var inputCheck = element.previousSibling.previousSibling;

    if (inputCheck.checked) {
      inputCheck.checked = false;
    } else {
      inputCheck.checked = true;
    }
  }

  resizeWindow() {
    if (this._screen() <= 641 && this.elements.windowDesk) {
      this.elements.btnFilter.classList.remove("active");
      this.elements.bodyFilter.classList.remove("active");
      this.elements.bodySort?.classList.remove("active-effect");
      this.elements.bodySort?.classList.remove("active");
      this.elements.btnSort?.classList.remove("active");
      if (this.elements.bodyFilter.classList.value.indexOf("filter-side") == -1) {
        this.elements.bodyFilter.style.height = "0px";
      }

      this.elements.windowDesk = false;
    } else if (this._screen() > 641 && !this.elements.windowDesk) {
      this.closeFilterSort();
      this.elements.windowDesk = true;
    }
  }

  closeFilterSort() {
    this.elements.btnFilter.classList.remove("active");
    this.elements.bodyFilterSortMobile.classList.remove("active");
    this.elements.bodyFilterSortMobile.classList.remove("body-sort");

    setTimeout(() => {
      this.classList.remove("active");
    }, 300);
  }

  _displayMobileFilterSort(option) {
    const _ref_bodyFilter = this.elements.bodyFilterSortMobile;

    this.classList.add("active");
    _ref_bodyFilter.classList.add("active");

    if (option == "sort") _ref_bodyFilter.classList.add("body-sort");
  }

  _visibleOptions(el) {
    let element = el.target.parentNode;

    if (!element.classList.contains("active")) {
      element.classList.add("active");
      el.target.innerText = "ver menos";
    } else {
      element.classList.remove("active");
      el.target.innerText = "ver mais";
    }

    this._updateHeightBodyFilter();
  }

  _visibleOptionsFilter(el) {
    let element = el.target;

    if (this._screen() > 641) return false;

    if (!element.classList.contains("filter-group-summary")) {
      element = element.parentNode;
      element = element.parentNode;
    }

    element = element.parentNode;

    element.classList.contains("close") ? element.classList.remove("close") : element.classList.add("close");
  }

  _updateHeightBodyFilter() {
    this.elements.bodyFilter.style.height = this.elements.heightFilter.clientHeight + 20 + "px";
  }

  displayFilter() {
    let _ref_bodyFilter = this.elements.bodyFilter;

    if (this._screen() < 641) {
      this._displayMobileFilterSort("filter");

      return false;
    }

    if (!this.elements.btnFilter.classList.contains("active")) {
      this.elements.btnFilter.classList.add("active");
      _ref_bodyFilter.classList.add("active");
      _ref_bodyFilter.style.height = this.elements.heightFilter.clientHeight + 20 + "px";
    } else {
      this.elements.btnFilter.classList.remove("active");
      _ref_bodyFilter.classList.remove("active");
      this.elements.bodyFilter.style.height = "0px";
    }
  }

  displaySort() {
    let _ref_bodySort = this.elements.groupSort;

    if (this._screen() < 641) {
      this._displayMobileFilterSort("sort");
      return false;
    }

    if (!this.elements.groupSort.classList.contains("active")) {
      _ref_bodySort.classList.add("active");
      this.elements.timeEffectSort = setTimeout(() => {
        _ref_bodySort.classList.add("active-effect");
      }, 10);
    } else {
      this._closeSort();
    }
  }

  _closeSort() {
    let _ref_bodySort = this.elements.groupSort;

    _ref_bodySort.classList.remove("active-effect");
    this.elements.timeEffectSort = setTimeout(() => {
      _ref_bodySort.classList.remove("active");
    }, 200);
  }

  _screen() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }
}

customElements.define("component-filter", ComponentFilter);
